import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import {
  MrfiktivUserControllerFindAllPaginatedParamsGen,
  MrfiktivUserViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import AdminSharedUserService from "@/services/shared/adminSharedUserService";
import { ThgUserControllerFindAllPaginatedParamsGen, ThgUserViewmodelGen } from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module } from "vuex-module-decorators";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "adminUserPagination",
  store
})
export class AdminUserPaginationStore extends BasePagination<
  ThgUserViewmodelGen | MrfiktivUserViewmodelGen,
  ThgUserControllerFindAllPaginatedParamsGen | MrfiktivUserControllerFindAllPaginatedParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: ThgUserViewmodelGen[] | MrfiktivUserViewmodelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;
  filterOptions: IPaginationFilterListElement[] = [
    { key: "userName", type: FilterTypes.STRING },
    { key: "firstName", type: FilterTypes.STRING },
    { key: "lastName", type: FilterTypes.STRING },
    { key: "company", type: FilterTypes.STRING },
    { key: "taxnumber", type: FilterTypes.STRING },
    { key: "contact.email", type: FilterTypes.STRING },
    { key: "contact.phone", type: FilterTypes.STRING },
    { key: "address.street", type: FilterTypes.STRING },
    { key: "address.zip", type: FilterTypes.STRING },
    { key: "address.city", type: FilterTypes.STRING },
    { key: "address.state", type: FilterTypes.STRING },
    { key: "authInfo.username", type: FilterTypes.STRING },
    { key: "authInfo.sub", type: FilterTypes.STRING },
    { key: "authInfo._id", type: FilterTypes.OBJECT_ID },
    { key: "isMarketingOptIn", type: FilterTypes.BOOLEAN },
    { key: "isTermsAccepted", type: FilterTypes.BOOLEAN },
    { key: "_id", type: FilterTypes.OBJECT_ID }
  ];

  @Action
  protected async loadDocuments(query: any): Promise<any> {
    return AdminSharedUserService.getAllPaginated(query);
  }
}

export const UserPaginationModule = getModule(AdminUserPaginationStore);
